import { combineReducers } from 'redux';
import WizardLaunchReducers from './WizardLaunchReducers';
import CartReducers from './CartReducers';
import PaypalReducer from './PaypalReducer';
import UserReducer from './UserReducer';

const rootReducer = combineReducers({
  wizardLaunch: WizardLaunchReducers,
  cart: CartReducers,
  paypal: PaypalReducer,
  user: UserReducer
});

export default rootReducer;